import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

export default function PrivateRoute({ children }) {
    const { authed } = useApp();
    return authed ? children : <Navigate to="/login" />;
}
